import * as types from '../types'
import * as eventApi from '../../api/core/events.dd'
import { setPriority } from 'os';
import { allResolved } from 'q';
import { store } from '../store';
import Vue from 'vue'

const state = {
  allEventSeverities:[],
  allEventTypes:[],
  unitTypeEvents:[],
  historicEvents:[],
  historicActions:[],
  allPredefinedEvents:[]
  /*
  eventWorkflow:[],
  */

}

const getters = {
  [types.EVENT_TYPES]: (state) => {
    return state.allEventTypes
  },
  [types.EVENT_SEVERITIES]: (state) => {
    return state.allEventSeverities
  },
  [types.UNIT_TYPE_EVENTS]: (state) => {
    return state.unitTypeEvents
  },
  [types.EVENTS_HISTORIC]: (state) => {
    return state.historicEvents
  },
  [types.ACTIONS_HISTORIC]: (state) => {
    return state.historicActions
  },
  [types.PREDEFINED_EVENTS]: (state) => {
    return state.allPredefinedEvents
  },
  /*
  [types.EVENT_WORKFLOW]: (state) => {
    return state.eventWorkflow
  },  
  */
}

const mutations = {
  [types.EVENT_TYPES]: (state, payload) => {
    state.allEventTypes = payload;
  },
  [types.EVENT_SEVERITIES]: (state, payload) => {
    state.allEventSeverities = payload;
  },
  [types.UNIT_TYPE_EVENTS]: (state, payload) => {
    state.unitTypeEvents = payload
  },
  [types.EVENTS_HISTORIC]: (state, payload) => {
    state.historicEvents = payload;
  },
  [types.ACTIONS_HISTORIC]: (state, payload) => {
    state.historicActions = payload;
  },
  [types.PREDEFINED_EVENTS]: (state, payload) => {
    state.allPredefinedEvents = payload;
  },
  /*
  [types.EVENT_WORKFLOW]: (state, payload) => {
    state.eventWorkflow = payload
  },
  */  
}

const actions = {
      [types.PREDEFINED_EVENTS]: ({ commit }, payload) => {
        let p = new Promise((resolve, reject) => {
            eventApi.getPredefinedEvents(payload.params).then((res) => {
                commit(types.PREDEFINED_EVENTS, res.data)
                resolve()
            }).catch((e) => {
              reject(e.result)
            })
        })
        return p
    },  
    [types.EVENT_TYPES]: ({ commit }, payload) => {
        let p = new Promise((resolve, reject) => {
            eventApi.allEventTypes(payload.params).then((res) => {
                commit(types.EVENT_TYPES, res.data)
                resolve()
            }).catch((e) => {
              reject(e.result)
            })
        })
        return p
    },
    [types.EVENT_SEVERITIES]: ({ commit }, payload) => {
        let p = new Promise((resolve, reject) => {
            eventApi.allEventSeverities(payload.params).then((res) => {
                commit(types.EVENT_SEVERITIES, res.data)
                resolve()
            }).catch((e) => {
              reject(e.result)
            })
        })
        return p
    },    
    [types.SAVE_UNIT_TYPE_EVENT]: ({ commit }, payload) => {
      
      let p = new Promise((resolve, reject) => {
          eventApi.saveUnitTypeEvent(payload.data).then((e) => {            
              resolve(e)
          }).catch((e) => {
            reject(e)
          })
      })
      return p
    },  
    [types.SAVE_UNIT_TYPE_ACTION_DONE_EVENT]: ({ commit }, payload) => {    
      let p = new Promise((resolve, reject) => {
          eventApi.saveUnitTypeActionDoneEvent(payload.data).then((e) => {            
              resolve(e)
          }).catch((e) => {
            reject(e)
          })
      })
      return p
    },  
    [types.SAVE_UNIT_TYPE_ACTION_CANCEL_EVENT]: ({ commit }, payload) => {
      
      let p = new Promise((resolve, reject) => {
          eventApi.saveUnitTypeActionCancelEvent(payload.data).then((e) => {            
              resolve(e)
          }).catch((e) => {
            reject(e)
          })
      })
      return p
    },          
    [types.SAVE_UNIT_TYPE_EVENT_ACTION]: ({ commit }, payload) => {
      
      let p = new Promise((resolve, reject) => {
          eventApi.saveUnitTypeEventAction(payload.data).then((e) => {            
              resolve(e)
          }).catch((e) => {
            reject(e)
          })
      })
      return p
    },           
    [types.UNIT_TYPE_EVENT]: ({ commit }, payload) => {    
      let p = new Promise((resolve, reject) => {        
          eventApi.getUnitTypeEvent(payload.data, payload.params).then((res) => {                        
              resolve(res.data)
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
    }, 
    [types.UNIT_TYPE_EVENTS]: ({ commit }, payload) => {    
      let p = new Promise((resolve, reject) => {        
          eventApi.getUnitTypeEvents(payload.data, payload.params).then((res) => {                 
              commit(types.UNIT_TYPE_EVENTS, res.data)                   
              resolve(res.data)
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
    },     
    [types.SAVE_ASSET_USER_EVENT]: ({commit}, payload) => {
      let p = new Promise((resolve, reject) => {        
          eventApi.saveAssetUserEvent(payload.data, payload.params).then((res) => {                 
              commit(types.SAVE_ASSET_USER_EVENT, res.data)                   
              resolve(res.data)
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p      
    },
    [types.EVENTS_HISTORIC]: ({ commit }, payload) => {
      let p = new Promise((resolve, reject) => {
          eventApi.getEventHistory(payload.data, payload.params).then((res) => {
              commit(types.EVENTS_HISTORIC, res.data)
              resolve()
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
    },
    [types.ACTIONS_HISTORIC]: ({ commit }, payload) => {
      let p = new Promise((resolve, reject) => {
          eventApi.getActionHistory(payload.data, payload.params).then((res) => {
              commit(types.ACTIONS_HISTORIC, res.data)
              resolve()
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
    },

  /*
  [types.EVENT_WORKFLOW]: ({commit}, payload) => {

      let p = new Promise((resolve, reject) => {
          eventApi.getUnitTypeEventWorkflow(payload.params).then( (res) => {
              commit(types.EVENT_WORKFLOW, res.data)
              resolve()
          }).catch((e) => {
              reject(e.result)
          })
      })
      return p
  },    
  */  
}


export default {
  state,
  getters,
  mutations,
  actions
}
